import {useContext, useEffect, useState} from "react";
import {driversSummary} from "../../../data/driversData";
import AppContext from "../../../contexts/appContext/app.context";
import {format} from "date-fns";
import LiveTrackService from "../../../services/liveTrack.service";
import {VideoTelematicService} from "../../../services/videTelematics.service";
import DateRangePicker from "../../../shared/dateRangePicker/dateRangePicker";
import CalendarType from "../../../shared/calendarType/calendarType";
import VideoTelematicsFilter from "../videoTelematicsFilter/videoTelematicsFilter";
import TelematicsOnDemandFilter from "../telematicsOnDemandFilter/telematicsOnDemandFilter";
import TelematicsOnDemandSec from "../telematicsOnDemandSec/telematicsOnDemandSec";
import TelematicsVideoList from "../telematicsVideoList/telematicsVideoList";
import Pagination from "../../../shared/pagination/pagination";
import VideoPlayer from "../../../shared/videoPlayer/videoPlayer";
import {NavLink} from "react-router-dom";

const TelematicsOnDemandVideos = () => {
    const [summary] = useState(driversSummary);
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [videoIndex, setVideoIndex] = useState(0);
    const [videoList, setVideoList] = useState([]);
    const [videoListLoader, setVideoListLoader] = useState(false);
    const [videoData, setVideoData] = useState({
        player: {},
        other: {}
    });
    const [pagination, setPagination] = useState({});
    const [vehicleIds, setVehicleIds] = useState(false);

    const [videoType, setVideoType] = useState('critical');


    const appCtx = useContext(AppContext);
    const [startDate, setStartDate] = useState(appCtx.startDate);
    const [endDate, setEndDate] = useState(appCtx.endDate);
    const startDateFormatted = format(new Date(startDate), 'yyyy-MM-dd');
    const endDateFormatted = format(new Date(endDate), 'yyyy-MM-dd');


    const handleShowVideoPlayer = (val, video) => {
        setShowVideoPlayer(val);
        setVideoData((prevState) => {
            return {
                ...prevState,
                player: {
                    videoLink: video?.preSignedUrl
                },
                other: {
                    alertType: video?.alertType,
                    timestampInISO: video?.videoStartTime,
                    plateNo: video?.plateNo
                }
            }
        });

        console.log(video);
    }
    const getVehicleIds = async () => {
        let vehicles = await LiveTrackService.getVehicles(startDateFormatted, endDateFormatted);
        const vehicleIds = vehicles?.map((vehicle) => vehicle.vehicleId);
        setVehicleIds(vehicleIds);

    }
    const getDvrVideoList = async (page = 1) => {
        setVideoListLoader(true);
        const userDetails = JSON.parse(localStorage.getItem("user-details"));
        const alerts = userDetails?.skuDetails?.alerts?.map((alrt) => alrt.alertString);
        const response = await VideoTelematicService.getDvrVideoList(alerts, vehicleIds, startDateFormatted, endDateFormatted, page);
        setVideoList(response.data);
        setPagination(response.meta);
        setVideoListLoader(false);
    }

    const handleDateChange = (date) => {
        if (date[1]) {
            setStartDate(date[0]);
            setEndDate(date[1]);
        }
    }

    const onPageChange = async (page) => {
        await getDvrVideoList(page);
    }


    useEffect(() => {
        (async () => {
            setVideoListLoader(true);
            await getVehicleIds();
            await getDvrVideoList();
            setVideoListLoader(false);
        })()
    }, [endDate])


    const handleRequestDVR = () => {


    }


    return (
        <>
            <div className={'video-telematics-sec page-fade-in'}>
                <div className={'content-section'}>
                    <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                        <DateRangePicker
                            startDate={startDate}
                            endDate={endDate}
                            selectRange={true}
                            onDateChange={handleDateChange} classes={'date width-300 item-height-40'}/>
                        <CalendarType/>
                    </div>
                </div>
                <div className="">
                    <div className={'content-section flex gap-0 align-top hr-space-between'}>
                        <div className="page-filter-sec">
                            <TelematicsOnDemandFilter/>
                        </div>
                        <div className="telematics-videos-box">
                            <div className="flex gap-50 margin-b-40 sf-medium">
                                <div className="">
                                    <NavLink to={'/videoTelematics/criticalAlerts'}>
                                        Critical Alert Videos
                                    </NavLink>
                                </div>
                                <div className="">
                                    <NavLink to={'/videoTelematics/onDemandVideos'} className={'highlight-color'}>
                                        On Demand Videos
                                    </NavLink>
                                </div>
                            </div>
                            <div className="margin-b-50">
                                <div className="margin-b-50"><TelematicsOnDemandSec handleRequestDVR={handleRequestDVR}/></div>
                                <div className="">
                                    <div className="section-title">Requested Videos</div>
                                    <TelematicsVideoList videoList={videoList} loader={videoListLoader}
                                                         handleShowVideoPlayer={handleShowVideoPlayer}/>
                                </div>
                                {(!videoList?.length > 0 && videoList?.message === undefined && !videoListLoader) &&
                                    <div className={'error-color text-align-center font-18 margin-t-30'}>Videos not
                                        available</div>
                                }
                            </div>
                            <div className="">
                                {videoList?.length > 0 &&
                                    <Pagination pages={pagination?.pageCount}
                                                currentPage={pagination?.currentPage}
                                                onPageChange={onPageChange}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*..... telematics video player ......*/}
            {/*{showVideoPlayer && <TelematicsVideoPlayer playerVideo={playerVideo} index={videoIndex} handleShowVideoPlayer={handleShowVideoPlayer} />}*/}
            {showVideoPlayer &&
                <VideoPlayer classes={'fixed'} videoData={videoData} handleShowVideoPlayer={handleShowVideoPlayer}/>}

        </>
    )
}

export default TelematicsOnDemandVideos;
